module.exports = __webpack_public_path__ + "img/saum_hellgrau_farbnummer705.2444e1c3.jpg";